import { useContext, useEffect, useState } from "react";
import MainContext from "../../_helpers/Contexts/mainContext";
import contrast from "../../Assets/highcontrast.svg";
import logo from "../../Assets/Herb.png";
import AnimateHeight from "react-animate-height";
import { confirm } from 'devextreme/ui/dialog';

const Navbar = () => {
  const { theme, setTheme } = useContext(MainContext);
  const { sizeTheme, setSizeTheme } = useContext(MainContext);
  const [height, setHeight] = useState();

  const controlNavbar = () => {
    if (window.scrollY > 80) setHeight(40);
    else setHeight(80);
  };

  const changeTheme = () => {
    if (setTheme) {
      if (theme === "theme-contrast") setTheme("default");
      else setTheme("theme-contrast");
    }
  };

  const step = 10;

  const zoomIn = () => {

    if (setSizeTheme && sizeTheme && sizeTheme < 150) {
      setSizeTheme(sizeTheme + step);
    }
  };

  const zoomOut = () => {
    if (setSizeTheme && sizeTheme && sizeTheme > 80) {
      setSizeTheme(sizeTheme - step);
    }
  };

  const resetZoom = () => {
    if (setSizeTheme) setSizeTheme(100);
  };

  useEffect(() => {
    setHeight(80);
    window.addEventListener("scroll", controlNavbar);
  }, []);

  const openDeclarationOfAvailability = async () => {
    const yes = await confirm(
      "Czy na pewno chcesz otworzyć nową kartę z deklaracją dostępności?", "UWAGA!"
    );
    if (yes) {
      window.open("https://bip.um.wroc.pl/deklaracja-dostepnosci");
    }
  }

  return (
    <nav className="navbar navBar">
      <div className="col-1 d-flex justify-content-center">
        <AnimateHeight
          id="siteLogo"
          className="siteLogo"
          duration={200}
          height={height}
          style={{ backgroundImage: `url(${logo})` }}
        >
          <></>
        </AnimateHeight>
      </div>
      <div id="navHeader" className="navHeader">
        <h1><span className="initial">e</span>-Status</h1>
      </div>
      <div className="float-right wcag">
        <a
          href="#"
          onClick={(e) => {
            openDeclarationOfAvailability();
          }}
        >
          <button className="wcag btn">Deklaracja dostępności</button>
        </a>
        <a href="" onClick={(e) => { e.preventDefault(); changeTheme() }}>
          <img
            src={contrast}
            alt="Zmiana kontrast strony"
            className="imgButton"
            onClick={changeTheme}
          /></a>
        <a href="" onClick={(e) => { e.preventDefault(); zoomOut(); }}>
          <span className="fontToLower" onClick={(e) => { e.preventDefault(); zoomOut(); }}>
            A-
          </span>
        </a>
        <a href="" onClick={(e) => { e.preventDefault(); resetZoom() }}>
          <span className="fontToNormal" onClick={(e) => { e.preventDefault(); resetZoom() }}>
            A
          </span>
        </a>
        <a href="" onClick={(e) => { e.preventDefault(); zoomIn() }}>
          <span className="fontToUpper" onClick={(e) => { e.preventDefault(); zoomIn() }}>
            A+
          </span></a>
      </div>
    </nav>
  );
};

export { Navbar };
